import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Good Old Maps</h3>
            <p>Explore nearby maps. Upload yours. Track your location.</p>
          </div>
          <div className="footer-section">
            <h4>Download</h4>
            <ul>
              <li>
                <a
                  href="https://apps.apple.com/us/app/good-old-maps/id6759081900"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  iOS App
                </a>
              </li>
              <li>
                <span className="footer-muted">Android (coming soon)</span>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li>
                <a href="/terms#terms-of-service">Terms of Service</a>
              </li>
              <li>
                <a href="/terms#privacy-policy">Privacy Policy</a>
              </li>
              <li>
                <a href="/terms#cookie-policy">Cookie Policy</a>
              </li>
              <li>
                <a href="/terms#data-processing">Data Processing</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Good Old Maps. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};



































